import { render } from "./BottomNavBar.vue?vue&type=template&id=0c38c032&scoped=true"
import script from "./BottomNavBar.vue?vue&type=script&lang=js"
export * from "./BottomNavBar.vue?vue&type=script&lang=js"

import "./BottomNavBar.vue?vue&type=style&index=0&id=0c38c032&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c38c032"]])

export default __exports__